import { useState } from 'react'

import { getCurrentAvailableLanguage } from '@/configuration/helpers/helpers'

const useLanguageRichTextInput = ({ languages, onChange, externalErrorLanguages, defaultLanguage }) => {
  const currentLanguage = getCurrentAvailableLanguage(languages, defaultLanguage)
  const [textLanguage, setTextLanguage] = useState(currentLanguage)

  const hasError = language => externalErrorLanguages.includes(language)

  const handleChange = data => {
    onChange(data.html, textLanguage)
  }

  return { textLanguage, setTextLanguage, hasError, handleChange }
}

export default useLanguageRichTextInput
